import React from "react";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Typography,
} from "@mui/material";
import ContactUsForm from "../../business/contactUsForm";
import { normalizeLicense } from "../homeShared";

export default function HomeDialogs({
  claimError,
  claimLoading,
  claimOpen,
  claimSubmitInFlight,
  claimTarget,
  claiming,
  demoOpen,
  handleClaimSubmit,
  license,
  setClaimOpen,
  setDemoOpen,
  setLicense,
}) {
  return (
    <React.Fragment>
      <Dialog open={demoOpen} onClose={() => setDemoOpen(false)} fullWidth maxWidth="sm">
        <DialogTitle>Request a Demo</DialogTitle>
        <DialogContent dividers>
          <ContactUsForm
            initialReason="demo"
            initialSubject="Request a Demo"
            initialMessage="I would like a live demo of Plany365 Care. Please contact me to schedule a walkthrough."
          />
        </DialogContent>
      </Dialog>

      <Dialog
        open={claimOpen}
        onClose={() => setClaimOpen(false)}
        fullWidth
        maxWidth="sm"
        disableEscapeKeyDown
      >
        <DialogTitle>Claim this business</DialogTitle>
        <DialogContent dividers>
          <Typography variant="body2" sx={{ mb: 1 }}>
            {claimTarget ? `Business: ${claimTarget.name}` : ""}
          </Typography>
          <Typography variant="body2" sx={{ mb: 2 }}>
            Only the owner or an authorized administrator should continue here. Enter the business
            or license number to start the claim. Viewing this business does not require claiming it.
          </Typography>
          <TextField
            autoFocus
            fullWidth
            label="License number"
            placeholder="AB12345"
            value={license}
            onChange={(event) => setLicense(event.target.value)}
            error={Boolean(claimError) && typeof claimError === "string"}
            helperText={
              typeof claimError === "string"
                ? claimError
                : "Enter the business or AFH license number only if you are claiming ownership or authorized management of this business."
            }
            onKeyDown={(event) => {
              if (event.key === "Enter") event.preventDefault();
              handleClaimSubmit();
            }}
          />
          {claimError && typeof claimError !== "string" ? <Box sx={{ mt: 2 }}>{claimError}</Box> : null}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setClaimOpen(false)} disabled={claiming || claimLoading}>
            Cancel
          </Button>
          <Button
            onClick={handleClaimSubmit}
            variant="contained"
            disabled={
              claiming ||
              claimLoading ||
              claimSubmitInFlight.current ||
              !normalizeLicense(license)
            }
          >
            {claimLoading || claiming ? "Submitting…" : "Submit Claim"}
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}
